import { addDoc, collection } from "firebase/firestore";
import React from "react";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateIncome = async (IncomeData, uid) => {
  try {
    const IncomeCollection = collection(db, "Incomes");

    let schoolId = localStorage.getItem("schoolId");

    schoolId = JSON.parse(schoolId);

    IncomeData = { ...IncomeData, schoolId };

    const data = HelperForMetaData({
      ...IncomeData,
      uid: uid,
    });
    await addDoc(IncomeCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateIncome;
